import { Injectable } from '@angular/core';
import { IKeyboardShortcutHandlerService } from './interfaces/keyboard-shortcut-handler-service.interface';
import { KeyboardShortcutElementSelectorService } from '../keyboard-shortcut-element-selector.service';
import { KeyboardShortcut } from '../../models/keyboard-shortcut.model';

@Injectable()
export class NativeSimpleClickKeyboardShortcutHandlerService implements IKeyboardShortcutHandlerService {

  constructor(private keyboardShortcutElementSelectorService: KeyboardShortcutElementSelectorService) {}

  handleEvent(shortcut: KeyboardShortcut): boolean {
    const element = this.keyboardShortcutElementSelectorService.selectElement(shortcut.selector);
    if (element) {
      setTimeout(() => {
        element.click();
      }, 0);
      return true;
    }
    return false;
  }

}
